import { Check } from "lucide-react";
import { SERVICES } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";
import { scrollToId } from "../lib/smoothScroll";

export const Services = () => (
  <section id="servizi" data-testid="services-section" className="relative py-24 sm:py-32 bg-[#231e16] border-y border-amber-500/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Servizi & Posa"
        title="Due modalità, un'unica garanzia di eccellenza"
        subtitle="Dalla semplice fornitura con ritiro al servizio full-service con posa in opera e regia dedicata."
        testId="services-title"
      />

      <div className="mt-14 grid gap-6 lg:grid-cols-2">
        {SERVICES.map((s, i) => (
          <Reveal key={s.type} delay={i * 0.15}>
            <article
              data-testid={`service-card-${i}`}
              className={`relative h-full p-8 sm:p-10 border transition-all duration-300 ${
                s.featured
                  ? "bg-[#2d261b] border-amber-400/50 shadow-[0_20px_60px_rgba(212,163,89,0.12)]"
                  : "bg-[#181410] border-amber-500/15 hover:border-amber-400/35"
              }`}
            >
              <span
                className={`inline-block text-[10px] font-mono uppercase tracking-[0.2em] px-3 py-1.5 border ${
                  s.featured
                    ? "bg-amber-400 text-[#181410] border-amber-400"
                    : "border-amber-500/25 text-amber-300"
                }`}
              >
                {s.badge}
              </span>
              <p className="mt-7 text-xs font-mono uppercase tracking-[0.25em] text-amber-400/90">{s.type}</p>
              <h3 className="mt-2 text-2xl sm:text-3xl font-serif text-[#FBF9F5]">{s.tagline}</h3>
              <p className="mt-3 text-sm text-stone-400">{s.subtitle}</p>
              <ul className="mt-7 space-y-3.5">
                {s.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-stone-300 leading-relaxed">
                    <Check className="w-4 h-4 mt-0.5 shrink-0 text-amber-400" />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`service-cta-${i}`}
                onClick={() => scrollToId("#preventivo")}
                className={`mt-9 w-full py-3.5 text-sm font-medium rounded-full transition-all duration-300 ${
                  s.featured
                    ? "bg-amber-400 text-[#181410] hover:bg-amber-300"
                    : "border border-amber-500/30 text-amber-300 hover:bg-amber-400/10 hover:border-amber-400/60"
                }`}
              >
                {s.cta}
              </button>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
